import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Modal, Form, Select, Input, DatePicker, Table } from 'antd';
import { UilPlus } from '@iconscout/react-unicons';
import { Cards } from '../../components/cards/frame/cards-frame';
import { Main } from '../styled';
import { alertModal } from '../../components/modals/antd-modals';
import { Button } from '../../components/buttons/buttons';
import { ProjectHeader, ProjectSorting } from '../project/style';
import { PageHeader } from '../../components/page-headers/page-headers';
import { useDispatch, useSelector } from 'react-redux';
import {
    taskDataSubmit,
    taskDataUpdate,
    assignedTasksDataRead,
    assignTaskToPersonDataSubmit,
} from '../../redux/tasks/actionCreator';
import { personDataRead } from '../../redux/person/actionCreator';
import CustomSpinner from '../ui-elements/spinner/CustomSpinner';
import { AutoComplete } from '../../components/autoComplete/autoComplete';
import moment from 'moment';
import Heading from '../../components/heading/heading';
import ProjectLists from './List';
import TextArea from 'antd/lib/input/TextArea';
import UilApps from '@iconscout/react-unicons/icons/uil-apps';
import UilListUl from '@iconscout/react-unicons/icons/uil-list-ul';
import { getItem } from '../../utility/localStorageControl';
import TaskProgress from './TaskProgress';
import { formatDate, formatDateAndTime } from '../../components/formatDate/FormatDate';
import Grid from './Grid';
import { notificationsDataDelete } from '../../redux/Notifications/actionCreator';
import { productDataRead } from '../../redux/Product/actionCreator';
import { projectDataRead } from '../../redux/project-links/actionCreator';
import { useParams } from 'react-router-dom';

const { Option } = Select;

function TaskManager({ forcedStatus = null, isStatusView = false }) {
    const params = useParams();
    const statusFromUrl = params.status;

    const normalizedStatus = (forcedStatus ?? statusFromUrl)
        ? decodeURIComponent(forcedStatus ?? statusFromUrl).toUpperCase().trim()
        : null;

    const role = getItem('role');
    const isAdmin = String(role).toUpperCase() === 'ADMIN';


    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [editForm] = Form.useForm();

    const dispatch = useDispatch();
    const {
        isGetProgressByTaskResLoading,
        projects,
        isLoadingProject,
        productdata,
        islodaingProductdata,
        isAssignTaskToPersonResloading,
        AssignTaskToPersonRes,
        isPersonsLoading,
        persons,
        isAssignedTasksResLoading,
        AssignedTasksRes,
        TaskAddRes,
        isTaskAddResLoading,
        TaskUpdateRes,
        isTaskUpdateResLoading,
    } = useSelector((state) => ({
        TaskAddRes: state.TaskAddRes.data,
        isTaskAddResLoading: state.TaskAddRes.loading,
        TaskUpdateRes: state.TaskUpdateRes.data,
        isTaskUpdateResLoading: state.TaskUpdateRes.loading,
        AssignedTasksRes: state.AssignedTasksRes.data,
        isAssignedTasksResLoading: state.AssignedTasksRes.loading,
        persons: state.PersonRes.data,
        isPersonsLoading: state.PersonRes.loading,
        AssignTaskToPersonRes: state.AssignTaskToPersonRes.data,
        isAssignTaskToPersonResloading: state.AssignTaskToPersonRes.loading,
        isGetProgressByTaskResLoading: state.GetProgressByTaskRes.loading,
        productdata: state.ProductGet.data,
        islodaingProductdata: state.ProductGet.loading,
        projects: state.ProjectRes.data,
        isLoadingProject: state.ProjectRes.loading,
    }));

    const productList = Array.isArray(productdata) ? productdata : [];
    const projectList = Array.isArray(projects) ? projects : [];

    useEffect(() => {
        dispatch(assignedTasksDataRead());
        dispatch(personDataRead());
        dispatch(productDataRead());
        dispatch(projectDataRead());
    }, [dispatch]);

    useEffect(() => {
        if (TaskAddRes && TaskAddRes?.Error === false) dispatch(assignedTasksDataRead());
    }, [TaskAddRes, dispatch]);

    useEffect(() => {
        if (TaskUpdateRes && TaskUpdateRes?.Error === false) dispatch(assignedTasksDataRead());
    }, [TaskUpdateRes, dispatch]);

    useEffect(() => {
        if (AssignTaskToPersonRes && AssignTaskToPersonRes?.Error === false)
            dispatch(assignedTasksDataRead());
    }, [AssignTaskToPersonRes, dispatch]);

    const [filtersData, setFiltersData] = useState([]);
    const [assignedTasksDataSource, setAssignedTasksDataSource] = useState([]);

    useEffect(() => {
        if (AssignedTasksRes?.length > 0) {
            const priorityOrder = { HIGH: 1, MEDIUM: 2, LOW: 3 };

            const sortedData = [...AssignedTasksRes].sort((a, b) => {
                if (a.status === 'FINISHED' && b.status !== 'FINISHED') return 1;
                if (b.status === 'FINISHED' && a.status !== 'FINISHED') return -1;

                if (a.person.length === 0 && b.person.length !== 0) return -1;
                if (b.person.length === 0 && a.person.length !== 0) return 1;

                if (a.person.length === 0 && b.person.length === 0)
                    return priorityOrder[a.priority] - priorityOrder[b.priority];

                if (priorityOrder[a.priority] !== priorityOrder[b.priority])
                    return priorityOrder[a.priority] - priorityOrder[b.priority];

                if (a.person.length !== b.person.length) return a.person.length - b.person.length;

                return new Date(b.createdon) - new Date(a.createdon);
            });

            const mapped = sortedData.map((item, index) => {
                const productIds =
                    (item.product && item.product.map((p) => p.id)) ||
                    item.productIds ||
                    [];

                const productNames =
                    (item.product && item.product.map((p) => p.productname)) || [];

                const personsArr =
                    item?.person?.map((person) => ({
                        name: person?.name,
                        imagename: person?.imagename,
                        username: person?.usermaster?.username,
                        id: person?.id,
                        usermasterId: person?.usermaster?.id,
                    })) || [];

                return {
                    id: item?.id,
                    sno: index + 1,
                    key: item?.id,
                    task: item?.title,
                    description: item?.description,
                    priority: item?.priority,
                    status: item?.status,
                    projectName: item?.project?.length > 0 ? item.project[0].project : 'NA',
                    assignedby: item?.assignedBy,
                    deadlineRaw: item?.deadline,
                    deadline: item?.deadline !== null ? formatDate(item?.deadline) : 'NA',

                    persons: personsArr,
                    personIds: personsArr.map((p) => p.id),
                    assignedToNames: personsArr.map((p) => p.name).join(', '),

                    progressLatestUpdate: item?.updatedon
                        ? formatDateAndTime(item.updatedon)
                        : 'NA',

                    productIds,
                    productNames,
                };
            });

            setFiltersData(mapped);
            setAssignedTasksDataSource(mapped);
        } else {
            setFiltersData([]);
            setAssignedTasksDataSource([]);
        }
    }, [AssignedTasksRes]);

    const handleButtonClick = () => setIsModalVisible(true);
    const handleModalCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const handleAddTask = () => {
        form.validateFields().then((values) => {
            dispatch(
                taskDataSubmit({
                    title: values.title,
                    description: values.description,
                    deadline: values.deadline ?? null,
                    priority: values.priority,
                    projectName: values.projectName,
                    // productIds: Array.isArray(values.productIds) ? values.productIds : [],
                    personIds: Array.isArray(values.persons) ? values.persons : [],
                })
            );

            form.resetFields();
            setIsModalVisible(false);
        });
    };

    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [editRecord, setEditRecord] = useState(null);
    const [editType, setEditType] = useState(false);

    const handleEdit = (record, flag) => {
        setEditType(flag);
        setEditRecord(record);
        setIsEditModalVisible(true);

        if (!flag) {
            editForm.setFieldsValue({ persons: record.personIds });
        } else {
            editForm.setFieldsValue({
                title: record.task,
                description: record.description,
                deadline: record.deadline !== 'NA' ? moment(record.deadlineRaw) : null,
                status: record.status,
                priority: record.priority,
            });
        }
    };

    const handleEditModalCancel = () => {
        setIsEditModalVisible(false);
        editForm.resetFields();
        setEditRecord(null);
    };

    const handleModalUpdate = () => {
        editForm.validateFields().then((values) => {
            if (!editType) {
                dispatch(
                    assignTaskToPersonDataSubmit({
                        taskIds: [editRecord?.id],
                        personIds: values.persons,
                    })
                );
            } else {
                dispatch(
                    taskDataUpdate({
                        id: editRecord?.id,
                        title: values.title,
                        description: values.description,
                        deadline: values.deadline ?? null,
                        status: values.status,
                        priority: values.priority,
                    })
                );
            }

            setIsEditModalVisible(false);
            editForm.resetFields();
            setEditRecord(null);
        });
    };

    const confirmAssignTask = (record) => {
        alertModal.confirm({
            title: `Are you sure you want to assign this task to you?`,
            content: `Once assigned, this task cannot be unassigned.`,
            onOk() {
                const personId = persons.filter(
                    (item) => item.usermaster.id === parseInt(getItem('userId'))
                );
                dispatch(
                    assignTaskToPersonDataSubmit({
                        personIds: [...record.personIds, personId[0]?.id],
                        taskIds: [record?.id],
                    })
                );
            },
        });
    };

    const [progressInfoModal, setProgressInfoModal] = useState(false);
    const [progressProps, setProgressProps] = useState({ id: null, title: '' });

    const handleProgressInfo = async (id, task, flag, NotificationsRes) => {
        setProgressProps({ id: parseInt(id), title: task });
        setProgressInfoModal(true);

        if (flag) {
            const notificationIds = NotificationsRes?.filter(
                (item) =>
                    item?.taskId === id &&
                    item?.usermasterId === parseInt(getItem('userId')) &&
                    item?.type === 'PROGRESS'
            )?.map((obj) => obj?.id);

            dispatch(notificationsDataDelete({ notificationId: notificationIds }));
        }
    };

    const handleNotificationDelete = (record, notificationData) => {
        const ids = notificationData
            ?.filter(
                (item) =>
                    item?.taskId === record?.key &&
                    item?.type === 'STATUS' &&
                    item?.usermasterId === parseInt(getItem('userId'))
            )
            ?.map((obj) => obj?.id);

        dispatch(notificationsDataDelete({ notificationId: ids }));
    };

    const [isCloneModalVisible, setIsCloneModalVisible] = useState(false);
    const [cloneForm] = Form.useForm();
    const [cloneBaseRecord, setCloneBaseRecord] = useState(null);

    const handleCreateFromExistingTask = (record) => {
        setCloneBaseRecord(record);
        setIsCloneModalVisible(true);
        cloneForm.resetFields();
    };

    const handleCloneModalCancel = () => {
        setIsCloneModalVisible(false);
        cloneForm.resetFields();
        setCloneBaseRecord(null);
    };

    const handleCreateFromExistingSubmit = () => {
        cloneForm.validateFields().then((values) => {
            dispatch(
                taskDataSubmit({
                    title: values.title,
                    description: values.description,
                    deadline: values.deadline ?? null,
                    priority: values.priority,
                    projectName: cloneBaseRecord?.projectName || null,
                    productIds: cloneBaseRecord?.productIds || [],
                })
            );

            cloneForm.resetFields();
            setIsCloneModalVisible(false);
            setCloneBaseRecord(null);
        });
    };

    const [searchText, setSearchText] = useState('');

    const finalData = useMemo(() => {
        let temp = [...filtersData];

        if (normalizedStatus) {
            temp = temp.filter(
                (t) =>
                    String(t.status || '').toUpperCase().trim() === normalizedStatus
            );
        }

        if (searchText) {
            const q = searchText.toLowerCase();
            temp = temp.filter((t) =>
                [
                    t.projectName,
                    t.task,
                    t.description,
                    t.assignedToNames,
                    (t.productNames || []).join(', '),
                    t.assignedby,
                    t.priority,
                    t.status,
                ]
                    .join(' ')
                    .toLowerCase()
                    .includes(q)
            );
        }

        return temp;
    }, [filtersData, normalizedStatus, searchText]);

    useEffect(() => {
        setAssignedTasksDataSource(finalData);
    }, [finalData]);

    const openStatusTab = (st) => {
        window.open(`tasks/status/${encodeURIComponent(st)}`, '_blank', 'noopener,noreferrer');
    };

    const [typeOfDisplay, setTypeOfDisplay] = useState(true);

    const [isDeadlineMissedModalVisible, setIsDeadlineMissedModalVisible] = useState(false);

    const deadlineMissedData = useMemo(() => {
        const today = moment().startOf('day');
        const allowedStatuses = ['IN PROGRESS', 'NOT STARTED'];

        return filtersData
            .filter((t) => t.deadlineRaw)
            .filter((t) => {
                const dl = moment(t.deadlineRaw).startOf('day');
                const st = String(t.status || '').toUpperCase().trim();
                return dl.isBefore(today) && allowedStatuses.includes(st);
            })
            .map((t) => {
                const dl = moment(t.deadlineRaw).startOf('day');
                return {
                    key: t.id,
                    task: t.task,
                    targetDate: formatDate(t.deadlineRaw),
                    daysMissed: today.diff(dl, 'days'),
                };
            })
            .sort((a, b) => b.daysMissed - a.daysMissed);
    }, [filtersData]);


    const deadlineColumns = [
        { title: 'Task Name', dataIndex: 'task', key: 'task' },
        { title: 'Target Date', dataIndex: 'targetDate', key: 'targetDate' },
        {
            title: 'Days Missed',
            dataIndex: 'daysMissed',
            key: 'daysMissed',
            sorter: (a, b) => a.daysMissed - b.daysMissed,
        },
    ];

    return (
        <>
            <ProjectHeader>
                <PageHeader
                    className="ninjadash-page-header-main"
                    ghost
                    title={`Manage Tasks${normalizedStatus ? ` - ${normalizedStatus}` : ''}`}
                    buttons={[
                        !isStatusView && (
                            <Button
                                key="deadlineMissed"
                                size="small"
                                style={{
                                    background: 'linear-gradient(135deg, #fff1f0, #ffccc7)',
                                    border: '1px solid #ff4d4f',
                                    color: '#a8071a',
                                    fontWeight: 600,
                                    borderRadius: 8,
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                    transition: 'all 0.2s ease-in-out',
                                }}
                                onClick={() => setIsDeadlineMissedModalVisible(true)}
                            >
                                Deadline Missed
                            </Button>
                        ),

                        role === 'ADMIN' && (
                            <Button
                                key="add"
                                type="primary"
                                size="small"
                                onClick={handleButtonClick}
                            >
                                <UilPlus /> Add New
                            </Button>
                        ),
                    ].filter(Boolean)}
                />

            </ProjectHeader>

            <Main>
                {isPersonsLoading ||
                    isGetProgressByTaskResLoading ||
                    isAssignedTasksResLoading ||
                    isTaskUpdateResLoading ||
                    isTaskAddResLoading ||
                    isAssignTaskToPersonResloading ||
                    islodaingProductdata ? (
                    <div className="custom-loading-spin-with-text">
                        <CustomSpinner />
                        <p style={{ fontWeight: 'bold', color: '#073886' }}>
                            Loading please wait...
                        </p>
                    </div>
                ) : (
                    <Row gutter={25}>
                        <Col xs={24}>
                            <ProjectSorting>
                                <div
                                    className="project-sort-bar"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-end',
                                        gap: 16,
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <div
                                        className="project-sort-nav"
                                        style={{
                                            display: 'flex',
                                            gap: 12,
                                            alignItems: 'flex-end',
                                            flexWrap: 'wrap',
                                            flex: 1,
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 280 }}>
                                            <strong style={{ marginBottom: 6 }}>Search</strong>
                                            <AutoComplete
                                                onSearch={(v) => setSearchText(v)}
                                                dataSource={finalData}
                                                placeholder="Search project / task / assigned to..."
                                                patterns
                                            />
                                        </div>
                                        {!isStatusView && isAdmin && (
                                            <div style={{ display: 'flex', gap: 12 }}>
                                                <Button
                                                    size="small"
                                                    onClick={() => openStatusTab('FINISHED')}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #e6fffb, #b5f5ec)',
                                                        border: '1px solid #13c2c2',
                                                        color: '#006d75',
                                                        fontWeight: 600,
                                                        borderRadius: 8,
                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                                        transition: 'all 0.2s ease-in-out',
                                                    }}
                                                >
                                                    Finished
                                                </Button>

                                                <Button
                                                    size="small"
                                                    onClick={() => openStatusTab('DROPPED')}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #fff1f0, #ffccc7)',
                                                        border: '1px solid #ff4d4f',
                                                        color: '#a8071a',
                                                        fontWeight: 600,
                                                        borderRadius: 8,
                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                                        transition: 'all 0.2s ease-in-out',
                                                    }}
                                                >
                                                    Dropped
                                                </Button>

                                                <Button
                                                    size="small"
                                                    onClick={() => openStatusTab('NOT STARTED')}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #fff7e6, #ffe7ba)',
                                                        border: '1px solid #fa8c16',
                                                        color: '#ad4e00',
                                                        fontWeight: 600,
                                                        borderRadius: 8,
                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                                        transition: 'all 0.2s ease-in-out',
                                                    }}
                                                >
                                                    Not Started
                                                </Button>
                                            </div>

                                        )}
                                        {/* ❌⏳✅ */}

                                    </div>

                                    {role === 'ADMIN' && (
                                        <div className="project-sort-group">
                                            <div className="layout-style">
                                                <div style={{ cursor: 'pointer' }} className="mr-10">
                                                    <UilListUl
                                                        size={36}
                                                        color={typeOfDisplay ? '#073886' : 'black'}
                                                        onClick={() => setTypeOfDisplay(true)}
                                                    />
                                                </div>
                                                <div style={{ cursor: 'pointer' }}>
                                                    <UilApps
                                                        color={!typeOfDisplay ? '#073886' : 'black'}
                                                        onClick={() => setTypeOfDisplay(false)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mt-30">
                                    {!typeOfDisplay ? (
                                        assignedTasksDataSource.length ? (
                                            <Row gutter={25}>
                                                <Grid
                                                    value={assignedTasksDataSource}
                                                    handleFunctionClick={handleProgressInfo}
                                                    handleEditFunctionProp={handleEdit}
                                                    handleDeleteStatusNotification={handleNotificationDelete}
                                                />
                                            </Row>
                                        ) : (
                                            <Col md={24}>
                                                <Cards headless>
                                                    <Heading>Data Not Found!</Heading>
                                                </Cards>
                                            </Col>
                                        )
                                    ) : (
                                        <ProjectLists
                                            value={assignedTasksDataSource}
                                            handleFunctionClick={handleProgressInfo}
                                            handleEditFunctionProp={handleEdit}
                                            handleAssignToMeFunctionProp={confirmAssignTask}
                                            persons={persons}
                                            handleDeleteStatusNotification={handleNotificationDelete}
                                            handleCreateFromExistingTask={handleCreateFromExistingTask}
                                        />
                                    )}
                                </div>
                            </ProjectSorting>
                        </Col>
                    </Row>
                )}
            </Main>

            <Modal
                title="Deadline Missed Tasks"
                open={isDeadlineMissedModalVisible}
                onCancel={() => setIsDeadlineMissedModalVisible(false)}
                maskClosable={false}
                width={700}
                footer={null}
            >
                {deadlineMissedData.length ? (
                    <Table
                        columns={deadlineColumns}
                        dataSource={deadlineMissedData}
                        pagination={{ pageSize: 8 }}
                    />
                ) : (
                    <Heading>No Deadline Missed Tasks </Heading>
                )}
            </Modal>

            <Modal
                title="Add Task"
                open={isModalVisible}
                onCancel={handleModalCancel}
                maskClosable={false}
                width={800}
                footer={[
                    <Button key="submit" type="primary" onClick={handleAddTask}>
                        Submit
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                        <Input placeholder="Enter title" />
                    </Form.Item>

                    {/* <Form.Item name="persons" label="Assigned to">
                        <Select mode="multiple" showSearch>
                            {persons?.map((p) => (
                                <Option key={p.id} value={p.id} searchValue={p?.usermaster?.username}>
                                    {p?.usermaster?.username}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item> */}
                    <Form.Item name="persons" label="Assigned to">
                        <Select
                            mode="multiple"
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {persons?.map((p) => (
                                <Select.Option
                                    key={p.id}
                                    value={p.id}
                                    label={p?.usermaster?.username}
                                >
                                    {p?.usermaster?.username}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <Form.Item name="description" label="Description" rules={[{ required: true }]}>
                        <TextArea rows={5} placeholder="Enter description" />
                    </Form.Item>

                    {/* <Form.Item name="productIds" label="Products" rules={[{ required: true }]}>
                        <Select placeholder="Select products" mode="multiple" allowClear>
                            {productList.map((prod) => (
                                <Option key={prod.id} value={prod.id}>
                                    {prod.productname}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item> */}

                    <Form.Item name="projectName" label="Project" rules={[{ required: true }]}>
                        <Select placeholder="Select project" allowClear>
                            {projectList.map((proj) => (
                                <Option key={proj.id} value={proj.project}>
                                    {proj.project}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item name="priority" label="Priority" rules={[{ required: true }]}>
                        <Select placeholder="Select Priority">
                            <Option value="LOW">LOW</Option>
                            <Option value="MEDIUM">MEDIUM</Option>
                            <Option value="HIGH">HIGH</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="deadline" label="Target Date">
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Select Target date"
                            disabledDate={(current) =>
                                current && current < moment().startOf('day')
                            }
                        />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title={
                    <span>
                        Create New Task for{' '}
                        <strong style={{ fontStyle: 'italic' }}>
                            {cloneBaseRecord?.projectName || 'Project'}
                        </strong>
                    </span>
                }
                open={isCloneModalVisible}
                onCancel={handleCloneModalCancel}
                maskClosable={false}
                width={800}
                footer={[
                    <Button key="create" type="primary" onClick={handleCreateFromExistingSubmit}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={cloneForm} layout="vertical">
                    <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                        <Input placeholder="Enter title" />
                    </Form.Item>

                    <Form.Item name="priority" label="Priority" rules={[{ required: true }]}>
                        <Select placeholder="Select Priority">
                            <Option value="LOW">LOW</Option>
                            <Option value="MEDIUM">MEDIUM</Option>
                            <Option value="HIGH">HIGH</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="deadline" label="Target Date">
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Select Target date"
                            disabledDate={(current) =>
                                current && current < moment().startOf('day')
                            }
                        />
                    </Form.Item>

                    <Form.Item name="description" label="Description" rules={[{ required: true }]}>
                        <TextArea rows={5} placeholder="Enter description" />
                    </Form.Item>
                </Form>

                {cloneBaseRecord && (
                    <div
                        style={{
                            marginTop: 16,
                            padding: 12,
                            borderRadius: 4,
                            border: '1px solid #f0f0f0',
                            background: '#fafafa',
                        }}
                    >
                        <strong>Task Details</strong>
                        <p style={{ marginTop: 8 }}>
                            <b>Project:</b> {cloneBaseRecord.projectName || 'NA'}
                        </p>
                        {/* <p>
                            <b>Products:</b>{' '}
                            {cloneBaseRecord.productNames?.length
                                ? cloneBaseRecord.productNames.join(', ')
                                : 'NA'}
                        </p> */}
                    </div>
                )}
            </Modal>

            <Modal
                title={
                    <span>
                        Progress Info of{' '}
                        <strong style={{ fontStyle: 'italic' }}>{progressProps?.title}</strong>
                    </span>
                }
                centered
                open={progressInfoModal}
                onCancel={() => setProgressInfoModal(false)}
                maskClosable={false}
                width={800}
                footer={null}
            >
                <TaskProgress data={progressProps} />
            </Modal>

            <Modal
                title={`${editType ? 'Edit Task' : `Manage Person(s) for ${editRecord?.task}`}`}
                open={isEditModalVisible}
                onCancel={handleEditModalCancel}
                maskClosable={false}
                width={800}
                footer={[
                    <Button key="update" type="primary" onClick={handleModalUpdate}>
                        Update
                    </Button>,
                ]}
            >
                <Form form={editForm} layout="vertical">
                    {editType ? (
                        <>
                            <Row gutter={25}>
                                <Col sm={12}>
                                    <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col sm={12}>
                                    <Form.Item name="priority" label="Priority" rules={[{ required: true }]}>
                                        <Select>
                                            <Option value="LOW">LOW</Option>
                                            <Option value="MEDIUM">MEDIUM</Option>
                                            <Option value="HIGH">HIGH</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={25}>
                                <Col sm={12}>
                                    <Form.Item name="status" label="Status" rules={[{ required: true }]}>
                                        <Select>
                                            <Option value="NOT STARTED">NOT STARTED</Option>
                                            <Option value="IN PROGRESS">IN PROGRESS</Option>
                                            <Option value="FINISHED">FINISHED</Option>
                                            <Option value="DEFERRED">DEFERRED</Option>
                                            <Option value="DROPPED">DROPPED</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col sm={12}>
                                    <Form.Item name="deadline" label="Deadline">
                                        <DatePicker
                                            disabledDate={(current) =>
                                                current && current < moment().startOf('day')
                                            }
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={25}>
                                <Col sm={24}>
                                    <Form.Item name="description" label="Description" rules={[{ required: true }]}>
                                        <TextArea rows={5} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <Form.Item name="persons" label="Person(s)">
                            <Select mode="multiple" showSearch>
                                {persons?.map((p) => (
                                    <Option key={p.id} value={p.id} searchValue={p?.usermaster?.username}>
                                        {p?.usermaster?.username}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        </>
    );
}

export default TaskManager;
